import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    getEnvironmentStageSelector,
    getEnvironmentVariables,
    getReportIssueDialogStatus
} from 'helpers/selectors';
import { mainMenuLinks } from './constants';
import { translate } from 'helpers/translateHelper';
import { triggerReportIssueDialog } from '../../actions';

const useMainMenuOptions = (setModalVisible, setCurrentModal) => {

    const { i18n } = useTranslation();
    const [menuOptions, setMenuOptions] = useState([]);

    const environment = useSelector(getEnvironmentStageSelector);
    const environmentVariables = useSelector(getEnvironmentVariables);

    const reportIssueDialogStatus = useSelector(getReportIssueDialogStatus);
    const dispatch = useDispatch();

    const orgManagement = {
        label: 'ABB.Powertrain.Frontend.mainMenu.orgMgt',
        href: environmentVariables.orgMgtUrl
    };

    const userLanguageCode = i18n.language;
    // Handler for report issue using global state
    const handleReportIssue = () => {
        // Dispatch global action
        dispatch(triggerReportIssueDialog({
            source: 'mainMenu',
            language: userLanguageCode,
            environment: environment
        }));
        // Also trigger local modal for backward compatibility
        //setModalVisible(true);
        // setCurrentModal({
        //     modalType: 'reportIssue'
        // });
    };
    useEffect(() => {
        // This effect will run whenever 'reportIssueDialogStatus' changes.
        if (reportIssueDialogStatus) {
            setModalVisible(true);
            setCurrentModal({
                modalType: 'reportIssue'
            });
        } else {
            setModalVisible(false);
        }
        // Perform side effects based on the new reportIssueDialogStatus
    }, [reportIssueDialogStatus]);


    useEffect(() => {
        setMenuOptions([
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.whatsNew',
                onClick: () => {
                    setModalVisible(true);
                    setCurrentModal({
                        modalType: 'whatsNewModalPDF', modalMetadata: {
                            title: translate('ABB.Powertrain.Frontend.whatsNewModalLabel')
                        }
                    });
                }
            },
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.allReleaseNotes',
                href: mainMenuLinks.allReleaseNotes
            },
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.onlineHelp',
                href: `${mainMenuLinks.onlineHelpLinks[environment]}${userLanguageCode}`
            },
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.reportIssue',
                onClick: () => {
                    handleReportIssue();
                }
            },
            ...environmentVariables.disableOrganizationManagement ? [orgManagement] : [],
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.eula',
                href: mainMenuLinks.eula
            },
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.abbAUP',
                href: mainMenuLinks.abbAUP
            },
            {
                label: 'ABB.Powertrain.Frontend.mainMenu.privacyPolicy',
                href: mainMenuLinks.privacyPolicy
            }
        ]);
    }, [userLanguageCode]);

    return menuOptions;
};

export default useMainMenuOptions;
